module.exports = __webpack_public_path__ + "static/media/Ronnie2.20b93caa.jpg";